import { Container, H2, FlexContainer } from "@carrotfertility/carotene"
import styled from "styled-components"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { IlloUnderwaterChecklist } from "components/views/atoms/Illustrations"
import { RoundedRectangle } from "components/views/atoms/roundedrectangle/RoundedRectangle"
import { RowItem } from "components/views/atoms/row/Row"
import React from "react"
import { BodySmall } from "../views/atoms/Bodies"
import { FormattedMessage } from "react-intl"

const ImageContainer = styled.div`
  display: flex;
  flex: 0;
`

const HeroMainContent = styled.div`
  display: flex;
  flex: 1;
`

const HeroText = styled.span`
  font-size: 17px;
  line-height: 1.5em;
`

// This should be able to be handled by a carotene component, but can't
// This should eventually be followed up on
// @ts-expect-error TS7031
function HeroWithImage({ children, image, spacing }) {
  return (
    <FlexContainer justifyContent="flex-end" wrap="wrap" direction="row-reverse">
      <ImageContainer>{image}</ImageContainer>
      <Container width={spacing}>{""}</Container>
      <HeroMainContent>{children}</HeroMainContent>
    </FlexContainer>
  )
}

export function OptOutOrExistingMemberCpHero(): JSX.Element {
  return (
    <RoundedRectangle backgroundColor="dark-blue">
      <HeroWithImage
        spacing="24px"
        image={
          <Container width="228px">
            <IlloUnderwaterChecklist />
          </Container>
        }
      >
        <RowItem minWidth="239px">
          <Container stack="medium">
            <H2 stack="tiny" variant="secondary">
              <FormattedMessage defaultMessage="Your Carrot Plan" />
            </H2>
            <BodySmall font="publico-text" color="white">
              <HeroText>
                <FormattedMessage defaultMessage="Update us about your journey so we can craft a free, personalized plan to support you." />
              </HeroText>
            </BodySmall>
          </Container>
          <ButtonPrimary to="/talk-to-carrot/get-your-carrot-plan">
            <FormattedMessage defaultMessage="Get your Carrot Plan" />
          </ButtonPrimary>
        </RowItem>
      </HeroWithImage>
    </RoundedRectangle>
  )
}
